import { useState, useMemo } from 'react';
import { FaArrowUp, FaArrowDown, FaSort } from "react-icons/fa";

export const useSortableTableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);

    const getValue = (obj, key) =>
        key.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);

    const sortedItems = useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
                const aValue = getValue(a, sortConfig.key);
                const bValue = getValue(b, sortConfig.key);

                if (aValue < bValue) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === 'ascending'
        ) {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getClassNamesFor = (key) => {
        if (!sortConfig) return;
        return sortConfig.key === key ? sortConfig.direction : undefined;
    };

    const renderSortArrow = (key) => {
        if (!sortConfig || sortConfig.key !== key) {
            return <FaSort />;
        }
        return sortConfig.direction === "ascending" ? <FaArrowUp /> : <FaArrowDown />;
    };

    return { items: sortedItems, requestSort, sortConfig, getClassNamesFor, renderSortArrow };
};
